"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const BaseAPIService_1 = require("./BaseAPIService");
const Services_1 = require("./Services");
class AccountService extends BaseAPIService_1.default {
    constructor(baseURL, token) {
        super(baseURL, 'account', token);
    }
    device(accountId) {
        return new Services_1.DeviceService(this.baseURL, this.token, accountId);
    }
    ddi(accountId) {
        return new Services_1.DDIService(this.baseURL, this.token, accountId);
    }
    setting(accountId) {
        return new Services_1.SettingService(this.baseURL, this.token, accountId);
    }
    trunk(accountId) {
        return new Services_1.TrunkService(this.baseURL, this.token, accountId);
    }
    asset(accountId) {
        return new Services_1.AssetService(this.baseURL, this.token, accountId);
    }
    webhook(accountId) {
        return new Services_1.WebhookService(this.baseURL, this.token, accountId);
    }
    status(accountId) {
        return new Services_1.AccountStatusService(this.baseURL, this.token, accountId);
    }
    events(accountId) {
        return new Services_1.EventGroupService(this.baseURL, this.token, accountId);
    }
    contacts(accountId) {
        return new Services_1.ContactService(this.baseURL, this.token, accountId);
    }
    calls(accountId) {
        return new Services_1.CallsService(this.baseURL, this.token, accountId);
    }
}
exports.default = AccountService;
